import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { IAssignmentType } from '../models/assignment-type';
import { AssignmentTypeService } from '../services/assignment-type.service';
import { NameValidators } from 'src/app/shared/validators/name.validators';

@Component({
    selector: 'app-assignment-type',
    templateUrl: './assignment-type.component.html',
    styleUrls: ['./assignment-type.component.css'],
    standalone: false
})
export class AssignmentTypeComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private assignmentTypeService: AssignmentTypeService,
    private appNotificationService: AppNotificationService
  ) { }

  assignmentTypes: IAssignmentType[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;

  ngOnInit(): void {
    this.assignmentTypes = this.route.snapshot.data.assignmentTypes as IAssignmentType[];
  }

  updateList() {
    this.assignmentTypeService.searchAssignmentTypes({ pageNumber: 0, pageSize: 999999 })
      .pipe(first())
      .subscribe(response => {
        this.assignmentTypes = response.data;
      });
  }

  addHandler({ sender }) {
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, NameValidators(() => this.assignmentTypes.map(a => a.name), 75, true)),
      isActive: new UntypedFormControl(true),
      sortOrder: new UntypedFormControl(0),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name,
        NameValidators(() => this.assignmentTypes.filter(a => a.id !== dataItem.id).map(a => a.name), 75, true)),
      isActive: new UntypedFormControl(dataItem.isActive),
      sortOrder: new UntypedFormControl(dataItem.sortOrder),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const id = event.dataItem.id ?? null;
    const request: any = {
      name: event.formGroup.value.name?.trim(),
      isActive: event.formGroup.value.isActive,
      sortOrder: event.formGroup.value.sortOrder,
      id,
    };

    const save$ = id
      ? this.assignmentTypeService.updateAssignmentType(request)
      : this.assignmentTypeService.createAssignmentType(request);

    // Close the row only on success, so the input survives a rejected save (errors are shown by the interceptor).
    save$.subscribe(() => {
      event.sender.closeRow(event.rowIndex);
      this.updateList();
    });
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.assignmentTypeService.deleteAssignmentType(dataItem.id)
      .subscribe({
        next: () => this.updateList(),
        error: (err: HttpErrorResponse) => {
          if (err.status === 409) {
            this.appNotificationService.notification$.next({
              message: 'Diese Auftragsart wird bereits in Aufträgen verwendet. Deaktivieren Sie sie stattdessen.',
              style: 'error'
            });
          } else {
            this.appNotificationService.notification$.next({
              message: 'Fehler beim Löschen der Auftragsart.',
              style: 'error'
            });
          }
        }
      });
  }
}
